import { Directive, ElementRef, AfterViewInit, Renderer2 } from '@angular/core';

@Directive({
    selector: '[appDashboardItemMenu]',
    standalone: false
})
export class DashboardMenuDirective implements AfterViewInit {
  constructor(
    private _host: ElementRef,
    private _renderer: Renderer2
  ) {}

  ngAfterViewInit() {
    const box = this._host.nativeElement.getBoundingClientRect();
    const elementFullHeight = box.height + box.top;
    if (elementFullHeight > window.innerHeight) {
      const marginTop = window.innerHeight - elementFullHeight;
      this._renderer.setStyle(this._host.nativeElement, 'margin-top', `${marginTop}px`);
    }
  }
}
